// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.

export const StandardFilters = undefined;

// Define the StandardFilters component in this file

// import { IndexForms } from "@hex-insights/app-modules";

// export function StandardFilters(props: IndexForms.StandardFiltersProps<PermissionGroupFilterFormValues.FilterFormValues>) {
// 	return null;
// }
